// Libraries
import { useEffect } from 'react';

// Style
import './App.scss';

import Routes from './routes/routes';
import { useDispatch, useSelector } from 'react-redux';
import { getLoggedInUserInfo } from './services/auth-service';
import { STORE_PERMISSIONS } from './redux/actions/permissionsActions';
import { LOGIN } from './redux/actions/authActions';
import { ensureFcmToken, requestNotificationPermission } from './services/notification-service';

function App() {
	const dispatch = useDispatch();
	const { authToken: token, pushEnabled } = useSelector((state) => state.auth);

	// Handle page reload - restore session and check notifications
	useEffect(() => {
		const navigationEntries = performance.getEntriesByType("navigation");
		const navigationType = navigationEntries.length > 0
			? navigationEntries[0].type
			: performance.navigation?.type === 1
				? "reload"
				: "navigate";

		if (navigationType === "reload") {
			onReloadPermission();
		}
	}, []);

	const onReloadPermission = async () => {
		if (token) {
			try {
				const response = await getLoggedInUserInfo(token);

				// Restore user session
				dispatch({ type: STORE_PERMISSIONS, payload: response.user.employee.employee_user_role_permission_matrix });
				dispatch({
					type: LOGIN,
					userId: response.user.id,
					name: response.user.employee.forename,
					imgsrc: response.user.employee.profile_photo,
					empId: response.user.employee.id,
					department: response.user.employee.department,
					teams: response.user.employee.teams,
					designation: response.user.employee.designation,
					token: token,
					employeeCreatedAt: response.user.employee.created_at,
					employeeEmails: response.user.employee.employee_emails,
					pushEnabled: response.push_enabled,
					filters:response.user.employee.filters
				});

				if (!response.push_enabled) {
					await requestNotificationPermission(response.token);
				}
			} catch (err) {
				console.error('Failed to reload user info:', err);
			}
		}
	};

	useEffect(() => {
		if (!token || pushEnabled === undefined) return; // Skip until authenticated and push_enabled known

		if (!("permissions" in navigator) || !("Notification" in window)) return;

		const handlePermissionChange = async (permission) => {
			console.log(`Notification permission changed to: ${permission.state}`);

			switch (permission.state) {
				case "granted":
					// Register/update token on grant (after initial checks)
					await ensureFcmToken();
					break;
				case "denied":
					// Clean up and respect denial
					permission.onchange = null;
					console.log("Notifications denied - no reprompt");
					// Optionally dispatch action to update push_enabled false
					break;
				case "prompt":
					// Do nothing - prompt only on user action
					break;
				default:
					break;
			}
		};

		let permission;

		(async () => {
			try {
				permission = await navigator.permissions.query({ name: "notifications" });
				// No initial handle here - assume initial grant/denial handled by login/push_enabled checks

				permission.onchange = () => handlePermissionChange(permission);
			} catch (err) {
				console.warn("Permissions API error:", err);
			}
		})();

		return () => {
			if (permission) permission.onchange = null;
		};
	}, [token, pushEnabled]); // Depend on auth and push_enabled

	return <Routes />;
}

export default App;